import React from "react";
import {
	Filter,
	DateInput,
	SearchInput,
	SelectInput,
	useTranslate,
	TextInput,
} from "react-admin";

const ModerableContentFilter = (props: any) => {
	const translate = useTranslate();

	return (
		<Filter {...props}>
			<SearchInput source="query" alwaysOn variant={"outlined"} />

			<DateInput
				source="published_at_gte"
				alwaysOn
				label={translate(
					"resources.moderable_contents.filters.from_publish_date",
				)}
				variant={"outlined"}
			/>
			<DateInput
				source="published_at_lte"
				alwaysOn
				label={translate(
					"resources.moderable_contents.filters.to_publish_date",
				)}
				variant={"outlined"}
			/>

			<SelectInput
				style={{ marginBottom: "0" }}
				source="status"
				resettable
				choices={[
					{
						id: "accepted",
						name: translate("resources.messages.status.accepted"),
					},
					{
						id: "pending",
						name: translate("resources.messages.status.pending"),
					},
					{
						id: "rejected",
						name: translate("resources.messages.status.rejected"),
					},
				]}
				alwaysOn
				variant={"outlined"}
			/>

			<TextInput
				label={translate("resources.moderable_contents.filters.batch_id")}
				source="batch_id"
				alwaysOn
				variant={"outlined"}
				resettable
			/>
		</Filter>
	);
};

export default ModerableContentFilter;
